<script setup>

import { onMounted } from 'vue'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question']);
const answerValue = defineModel('answerValue');
const answerNote = defineModel('answerNote');

const handleInput = () => {
  if (!props.handleAnswer){
    return;
  }
  if (answerValue.value !== null && answerValue.value.trim() !== '') {
    props.handleAnswer(props.question['reference'], answerValue.value, false, answerNote.value);
  } else {
    props.handleAnswer(props.question['reference'], null, false, answerNote.value);
  }
}

onMounted(() => {
  props.compiledPoll['answers'].forEach(el => {
    if (el['questionReference'] === props.question['reference']) {
      if(el['note']) answerNote.value = el['note'];
      if (el['value']) {
        answerValue.value = el['value'];
      }
    }
  })
})
</script>

<template>
  <div class="pe-2">
    <label :for="'textQuestion'+question['id']" :class="'form-label'+ (question.required ? ' fw-bold ' : '')">{{ question.text }} {{ question.required ? '*' : '' }}</label>
    <input v-if="compiledPoll['state'] !== 'filled' && handleAnswer !== null" @change="handleInput" v-model="answerValue" :id="'textQuestion'+question['id']" class="form-control" type="text" :required="question.required" :name="question['id']"/>
    <textarea v-else disabled v-model="answerValue"  class="form-control" rows="5" style="resize:none;"></textarea>
    <small v-if="question.helper" class="form-text">{{ question.helper }}</small>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">Note</label>
        <textarea @change="handleInput"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">

</style>
